import React from 'react';

export const Schedule = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="16.5" cy="7.5" r="5.41667" stroke="black" strokeWidth="1.5" />
    <path
      d="M16.5 3.97917L16.5 7.60834L18.3958 9.39584"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      clipRule="evenodd"
      d="M11.8636 4H7.83375C4.61218 4 1 6.5 1 11.7047C1 16 4.61269 18.4093 7.83417 18.4093H15.1667L18.186 21.7968C19.4788 22.429 21 21.5096 21 20.096V11.7047L20.9953 11.6677L19.3333 12.037V20.096C19.3333 20.096 19.116 20.4293 18.9313 20.339L15.7361 16.8654L15.5673 16.7794H15.3634H7.83417C5.5328 16.7794 2.66667 15.5 2.66667 11.7047C2.66667 7.36141 5.53248 5.6299 7.83375 5.6299L11.6414 5.6299L11.8636 4Z"
      fill="black"
      fillRule="evenodd"
      id="scheduleFill"
    />
  </svg>
);
